import * as Controls from '../../ui/UIControlsNames';

export const VIDEO_JS_DEFAULTS = {
    'controls': true,
    'autoplay': true,
    'preload': 'auto',
    'poster': '',
    'loop': false,

    // Default order of fallback technology
    'techOrder': ['html5'],

    'html5': {},

    // Default of web browser is 300x150. Should rely on source width/height.
    'width': '100%',
    'height': 0,
    // defaultVolume: 0.85, // doesn't seem to do anything

    // default playback rates
    'playbackRates': [],

    // default inactivity timeout
    'inactivityTimeout': 500,

    // Included control sets
    'children': [
        'mediaLoader',
        'bigPlayButton',
        'loadingSpinner',
        'posterImage',
        'controlBar'
    ],

    'language': document.getElementsByTagName('html')[0].getAttribute('lang') || navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language || 'en',

    // locales and their language translations
    'languages': {},

    // Default message to show when a video cannot be played.
    'notSupportedMessage': 'No compatible source was found for this video.'
};




// WEBPACK FOOTER //
// ./src/player/defaults/VideoJS.js